(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AsciiFactory = require('./factories/AsciiFactory');

var _AsciiFactory2 = _interopRequireDefault(_AsciiFactory);

var _CharacterSetFactory = require('./factories/CharacterSetFactory');

var _CharacterSetFactory2 = _interopRequireDefault(_CharacterSetFactory);

var _ImageFactory = require('./factories/ImageFactory');

var _ImageFactory2 = _interopRequireDefault(_ImageFactory);

var _CanvasService = require('./services/CanvasService');

var _CanvasService2 = _interopRequireDefault(_CanvasService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var App = (function () {
    function App(options) {
        var _this = this;

        _classCallCheck(this, App);

        this.imageFile = undefined;

        this.inputFileElement = options.inputFileElement;
        this.inputFilePreviewElement = options.inputFilePreviewElement;
        this.inputCharacterSetElement = options.inputCharacterSetElement;
        this.inputSizeElement = options.inputSizeElement;
        this.inputLineHeightElement = options.inputLineHeightElement;
        this.characterSetRangeElement = options.characterSetRangeElement;
        this.btnPreset = options.btnPreset;
        this.btnStartElement = options.btnStartElement;
        this.outputElement = options.outputElement;

        this.addInputEventListeners();
        this.setCharacterSetFromPreset(this.getPresets().ascii);

        this.btnStartElement.addEventListener('click', function () {
            if (!_this.isValid()) return;

            _this.generateAscii(_this.imageFile).then(function (ascii) {
                _this.outputElement.innerHTML = _this.escapeHtml(ascii);
            });
        });
    }

    _createClass(App, [{
        key: 'addInputEventListeners',
        value: function addInputEventListeners() {
            var _this2 = this;

            var handleFile = function handleFile(file) {
                _this2.inputFileElement.parentNode.classList.remove('form__control--error');

                _ImageFactory2.default.getImageFromFile(file).then(function (image) {
                    _this2.inputFilePreviewElement.style.backgroundImage = 'url(' + image.src + ')';
                    _this2.inputFilePreviewElement.parentNode.classList.add('file-uploader--preview');
                    _this2.imageFile = file;
                }).catch(function (err) {
                    _this2.imageFile = undefined;
                });
            };

            this.inputFileElement.addEventListener('change', function () {
                if (!_this2.inputFileElement.files.length) return;
                handleFile(_this2.inputFileElement.files[0]);
            });

            // Enable dropping files
            this.inputFileElement.parentNode.addEventListener('dragover', function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this2.inputFileElement.parentNode.classList.add('file-uploader--highlight');
            });
            this.inputFileElement.parentNode.addEventListener('dragleave', function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this2.inputFileElement.parentNode.classList.remove('file-uploader--highlight');
            });
            this.inputFileElement.parentNode.addEventListener('drop', function (e) {
                e.stopPropagation();
                e.preventDefault();
                handleFile(e.dataTransfer.files[0]);
                _this2.inputFileElement.parentNode.classList.remove('file-uploader--highlight');
            });

            this.inputCharacterSetElement.addEventListener('change', function () {
                _this2.inputCharacterSetElement.classList.remove('form__control--error');
            });

            this.inputCharacterSetElement.addEventListener('change', function () {
                _this2.inputCharacterSetElement.classList.remove('form__control--error');
            });

            var _loop = function _loop(charset) {
                _this2.btnPreset[charset].addEventListener('click', function () {
                    var presets = _this2.getPresets();
                    _this2.setCharacterSetFromPreset(presets[charset]);
                    _this2.inputLineHeightElement.value = App.LINE_HEIGHT[charset];
                });
            };

            for (var charset in this.btnPreset) {
                _loop(charset);
            }

            this.inputCharacterSetElement.addEventListener('change', function () {
                return _this2.selectCharacterSet();
            });
            this.inputCharacterSetElement.addEventListener('keyup', function () {
                return _this2.selectCharacterSet();
            });
        }
    }, {
        key: 'setCharacterSetFromPreset',
        value: function setCharacterSetFromPreset(characterSet) {
            this.inputCharacterSetElement.value = characterSet.join('');
            this.selectCharacterSet();
        }
    }, {
        key: 'getCharacterSet',
        value: function getCharacterSet() {
            var characterSet = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.inputCharacterSetElement.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var character = _step.value;

                    if (characterSet.indexOf(character) >= 0) continue;
                    characterSet.push(character);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return characterSet;
        }
    }, {
        key: 'selectCharacterSet',
        value: function selectCharacterSet() {
            var characterSet = this.getCharacterSet(),
                canvas = this.characterSetRangeElement,
                context = canvas.getContext('2d'),
                lightnessRangeCount = {};
            var maxLightnessCount = 0;

            this.characterLightnessSet = _CanvasService2.default.normalizeCharacterLightness(_CanvasService2.default.getCharacterLightnessSet(characterSet, App.FONT_SIZE));
            this.characterLightnessSet = this.characterLightnessSet.sort(function (a, b) {
                return b.lightness - a.lightness;
            });

            this.characterLightnessSet.forEach(function (character) {
                var lightnessString = Math.floor(character.lightness * characterSet.length).toString();

                if (!lightnessRangeCount[lightnessString]) {
                    lightnessRangeCount[lightnessString] = 0;
                }

                lightnessRangeCount[lightnessString]++;
                maxLightnessCount = Math.max(lightnessRangeCount[lightnessString], maxLightnessCount);
            });

            canvas.height = 25;
            canvas.width = characterSet.length;

            context.clearRect(0, 0, canvas.width, canvas.height);
            context.strokeStyle = 'rgba(0, 0, 0, .5)';

            for (var x in lightnessRangeCount) {
                context.moveTo(x, canvas.height);
                context.lineTo(x, canvas.height - lightnessRangeCount[x] / maxLightnessCount * canvas.height);
            }

            context.stroke();
        }
    }, {
        key: 'generateAscii',
        value: function generateAscii(file) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                _ImageFactory2.default.getImageFromFile(file).then(function (image) {
                    var width = _this3.inputSizeElement.value,
                        height = width / image.width * image.height / _this3.inputLineHeightElement.value,
                        canvas = _CanvasService2.default.getCanvasFromImage(image, width, height),
                        context = canvas.getContext('2d'),
                        imageData = context.getImageData(0, 0, canvas.width, canvas.height),
                        imageLightnessData = _CanvasService2.default.getImageLightnessData(imageData);

                    imageLightnessData.data = _CanvasService2.default.normalizeLightness(imageLightnessData.data);

                    if ('Worker' in window) {
                        var worker = new Worker('assets/scripts/ascii-factory.js');
                        worker.onmessage = function (e) {
                            return resolve(e.data);
                        };
                        worker.postMessage({
                            characterLightnessSet: _this3.characterLightnessSet,
                            imageLightnessData: imageLightnessData
                        });
                    } else {
                        resolve(_AsciiFactory2.default.getAscii(_this3.characterLightnessSet, imageLightnessData));
                    }
                }).catch(function (e) {
                    console.error(e);
                });
            });
        }
    }, {
        key: 'getPresets',
        value: function getPresets() {
            return {
                ascii: _CharacterSetFactory2.default.getCharacterSet(0x20, 0x7E),

                // TODO: Add more emoji
                // Source: https://en.wikipedia.org/wiki/Emoji#In_the_Unicode_standard
                emoji: _CharacterSetFactory2.default.getCharacterSet(0x1F600, 0x1F64F),
                latin: Array.prototype.concat(_CharacterSetFactory2.default.getCharacterSet(0x20, 0x7E), _CharacterSetFactory2.default.getCharacterSet(0xA1, 0x17F))
            };
        }
    }, {
        key: 'escapeHtml',
        value: function escapeHtml(html) {
            return html.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            var isValid = true;

            if (!this.imageFile) {
                this.inputFileElement.parentNode.classList.add('form__control--error');
                isValid = false;
            }

            if (!this.inputCharacterSetElement.value) {
                this.inputCharacterSetElement.classList.add('form__control--error');
                isValid = false;
            }

            if (isNaN(parseInt(this.inputSizeElement.value)) || this.inputSizeElement.value < 2) {
                this.inputSizeElement.classList.add('form__control--error');
                isValid = false;
            }

            if (isNaN(parseFloat(this.inputLineHeightElement.value))) {
                this.inputLineHeightElement.classList.add('form__control--error');
                isValid = false;
            }

            return isValid;
        }
    }]);

    return App;
})();

exports.default = App;

App.FONT_SIZE = 12;
App.LINE_HEIGHT = {
    ascii: 1.8,
    latin: 1.8,
    emoji: 1.2
};

window.App = App;

},{"./factories/AsciiFactory":2,"./factories/CharacterSetFactory":3,"./factories/ImageFactory":4,"./services/CanvasService":5}],2:[function(require,module,exports){
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AsciiFactory = (function () {
    function AsciiFactory() {
        _classCallCheck(this, AsciiFactory);
    }

    _createClass(AsciiFactory, null, [{
        key: 'getAscii',
        value: function getAscii(characterLightnessSet, imageLightnessData) {
            var ascii = '',
                find = function find(lightness) {
                var match = undefined;

                characterLightnessSet.forEach(function (character) {
                    if (match && Math.abs(lightness - character.lightness) >= Math.abs(lightness - match.lightness)) return;

                    match = character;
                });

                return match.character;
            };

            imageLightnessData.data.forEach(function (lightness, i) {
                if (i > 0 && i % imageLightnessData.width === 0) {
                    ascii += '\r\n';
                }

                ascii += find(lightness);
            });

            return ascii;
        }
    }]);

    return AsciiFactory;
})();

exports.default = AsciiFactory;

},{}],3:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CharacterSetFactory = (function () {
    function CharacterSetFactory() {
        _classCallCheck(this, CharacterSetFactory);
    }

    _createClass(CharacterSetFactory, null, [{
        key: "getCharacterSet",
        value: function getCharacterSet(start, end) {
            var characterSet = [];

            for (var i = start; i <= end; i++) {
                characterSet.push(String.fromCodePoint(i));
            }

            return characterSet;
        }
    }]);

    return CharacterSetFactory;
})();

exports.default = CharacterSetFactory;

},{}],4:[function(require,module,exports){
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageFactory = (function () {
    function ImageFactory() {
        _classCallCheck(this, ImageFactory);
    }

    _createClass(ImageFactory, null, [{
        key: 'getImageFromFile',
        value: function getImageFromFile(file) {
            var reader = new FileReader(),
                image = new Image();

            return new Promise(function (resolve, reject) {
                reader.addEventListener('load', function () {
                    image.src = reader.result;
                });

                image.addEventListener('load', function () {
                    resolve(image);
                });

                reader.addEventListener('error', reject);
                image.addEventListener('error', reject);
                reader.readAsDataURL(file);
            });
        }
    }]);

    return ImageFactory;
})();

exports.default = ImageFactory;

},{}],5:[function(require,module,exports){
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasService = (function () {
    function CanvasService() {
        _classCallCheck(this, CanvasService);
    }

    _createClass(CanvasService, null, [{
        key: 'getCanvasFromImage',
        value: function getCanvasFromImage(image, width, height) {
            var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d');

            canvas.height = Math.round(height);
            canvas.width = Math.round(width);

            context.fillStyle = '#fff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, 0, 0, canvas.width, canvas.height);

            return canvas;
        }
    }, {
        key: 'getCharacterLightnessSet',
        value: function getCharacterLightnessSet(characterSet, fontSize) {
            var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                characterLightnessSet = [];

            canvas.height = fontSize;
            canvas.width = fontSize;

            context.fontStyle = fontSize + 'px monospace';

            characterSet.forEach(function (character) {
                context.fillStyle = '#fff';
                context.fillRect(0, 0, canvas.width, canvas.height);

                context.fillStyle = '#000';
                context.fillText(character, 0, canvas.height);

                var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                characterLightnessSet.push({
                    character: character,
                    lightness: CanvasService.getCanvasLightness(imageData)
                });
            });

            return characterLightnessSet.filter(function (character) {
                return character.lightness > 0 || character.character === 0x20;
            });
        }
    }, {
        key: 'getImageLightnessData',
        value: function getImageLightnessData(imageData) {
            var lightnessData = [];

            CanvasService.forEachPixel(imageData, function (r, g, b, a) {
                lightnessData.push((r + g + b) / 3);
            });

            return {
                data: lightnessData,
                height: imageData.height,
                width: imageData.width
            };
        }
    }, {
        key: 'getCanvasLightness',
        value: function getCanvasLightness(imageData) {
            var imageLightnessData = CanvasService.getImageLightnessData(imageData),
                sum = function sum(previous, current) {
                return previous + current;
            };

            return imageLightnessData.data.reduce(sum, 0) / imageLightnessData.data.length;
        }
    }, {
        key: 'forEachPixel',
        value: function forEachPixel(imageData, callback) {
            var pixelData = imageData.data;

            for (var i = 0; i < pixelData.length; i += 4) {
                callback(pixelData[i], pixelData[i + 1], pixelData[i + 2], pixelData[i + 3], i);
            }
        }
    }, {
        key: 'normalizeCharacterLightness',
        value: function normalizeCharacterLightness(lightnessData) {
            var lightnessMin = Infinity,
                lightnessMax = -Infinity;

            lightnessData.forEach(function (obj) {
                lightnessMin = Math.min(obj.lightness, lightnessMin);
                lightnessMax = Math.max(obj.lightness, lightnessMax);
            });

            return lightnessData.map(function (obj) {
                obj.lightness = (obj.lightness - lightnessMin) / (lightnessMax - lightnessMin);
                return obj;
            });
        }
    }, {
        key: 'normalizeLightness',
        value: function normalizeLightness(lightnessData) {
            var lightnessMin = Infinity,
                lightnessMax = -Infinity;

            lightnessData.forEach(function (lightness) {
                lightnessMin = Math.min(lightness, lightnessMin);
                lightnessMax = Math.max(lightness, lightnessMax);
            });

            return lightnessData.map(function (lightness) {
                return (lightness - lightnessMin) / (lightnessMax - lightnessMin);
            });
        }
    }]);

    return CanvasService;
})();

exports.default = CanvasService;

},{}]},{},[1]);
